import {ResolutionUtils} from "../../infrastructure/utils/resolution-utils";
import {computed, observable, makeObservable} from "mobx";
import {BaseViewModel} from "../../infrastructure/models/base-view-model";
import {DomUtils} from "../../infrastructure/utils/dom-utils";
import {singleton} from "../../infrastructure/decorators/singleton";

@singleton
export class DeviceViewModel extends BaseViewModel {
  @observable _screenSize: Number;
  @observable direction: String;
  @observable orientation: String;
  domUtils: DomUtils;
  resolutionUtils: ResolutionUtils;

  static injectables = [DomUtils, ResolutionUtils]

  constructor(domUtils: DomUtils, resolutionUtils: ResolutionUtils) {
    super({});

    this.domUtils = domUtils;
    this.resolutionUtils = resolutionUtils;
    this._screenSize = resolutionUtils.screenWidth;
    this.direction = 'ltr';
    this.orientation = resolutionUtils.orientation;

    makeObservable(this);
  }

  @computed get screenWidth() {
    const size = this.resolutionUtils.screenWidth.toString();

    return size;
  }

  @computed get screenSize() {
    const size = this.resolutionUtils.resolveScreenSize(this.resolutionUtils.screenWidth);

    return size;
  }
  @computed get isSmallView() {
    return !this.isLargeView || this.isMediumView;
  }

  @computed get isMediumView() {
    return this.resolutionUtils.isMediumView(this.screenSize);
  }

  @computed get isLargeView() {
    return this.resolutionUtils.isLargeView(this.screenSize);
  }

  // @computed get fontSizes() {
  //   const size = FONT_TO_SCREEN_SIZES[this.screenSize];
  //
  //   return size;
  // }

  @computed get isRtl() {
    const isRtl = this.direction === 'rtl';

    return isRtl;
  }

  @computed get height() {
    return this.domUtils.height;
  }
}
